import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';

const localStorageProvider = createLocalStorageProvider('jira-redaction-flag');
const key = 'lastViewedTimestamp';

export const setLastViewedTimestamp = (issueKey: string) => {
	const timestampMap = localStorageProvider.get(key) || {};
	timestampMap[issueKey] = new Date().getTime();
	localStorageProvider.set(key, timestampMap);
};

export const getLastViewedTimestamp = (issueKey: string): number => {
	const timestampMap = localStorageProvider.get(key) || {};
	return timestampMap[issueKey] || 0;
};
